import { render, staticRenderFns } from "./CompanyIntro.vue?vue&type=template&id=49f656a2&scoped=true&"
import script from "./CompanyIntro.vue?vue&type=script&lang=js&"
export * from "./CompanyIntro.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIntro.vue?vue&type=style&index=0&id=49f656a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f656a2",
  null
  
)

export default component.exports